var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tlds-table-provider',{attrs:{"id":"DT1","limit":12}},[_c('tlds-table')],1)}
var staticRenderFns = []

export { render, staticRenderFns }